import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ConfigService } from '../../../services/config.service';
declare var $: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'dynamic-form',
    templateUrl: './dynamic-form.component.html',
    styleUrls: ['./dynamic-form.component.css']
})
export class DynamicFormComponent implements OnChanges, OnInit {
    @Input()
    config: any[] = [];

    form: FormGroup;
    canViewEditForm = false;
    public isCollapsed = true;
    fieldConfig: any = {};

    constructor(private fb: FormBuilder, private configService: ConfigService) { }

    ngOnInit() {
        // this.configService.cast.subscribe(config => this.config = [...config]);
    }

    ngOnChanges() {
        this.config = this.configWithDisplayName();
        this.form = this.createGroup();
    }

    configWithDisplayName() {
        return this.config.map(fieldConfig => {
            let field = this.configService.formFieldsToAdd.find(field => {
                return field.value === (fieldConfig.input_type || fieldConfig.type)
            });
            fieldConfig['displayName'] = field ? field.name : '';
            return fieldConfig;
        });
    }

    createGroup() {
        const group = this.fb.group({});
        this.config.filter(this.notCheckBox).forEach(control => group.addControl(control.name, this.fb.control('')));
        this.config.filter(this.isCheckBox).forEach(control => group.addControl(control.name, this.buildCheckBoxOptions(control)));
        return group;
    }

    notCheckBox(field) {
        return field.type !== 'checkbox';
    }

    isCheckBox(field) {
        return field.type === 'checkbox';
    }

    buildCheckBoxOptions(fieldControl) {
        const arr = fieldControl.choices.map(choice => {
            return this.fb.control(false);
        });
        return this.fb.array(arr);
    }

    drop(event: CdkDragDrop<string[]>) {
        this.closeEditForm();
        moveItemInArray(this.config, event.previousIndex, event.currentIndex);
        for (let i = 0; i < this.config.length; i++) {
            this.config[i].position = i + 1;
        }
        this.configService.editConfig(this.config);
    }

    deleteFormElement(index) {
        this.closeEditForm();
        this.config.splice(index, 1);
        this.configService.editConfig([...this.config]);
    }

    viewEditForm(index) {
        console.log(this.config);
        this.canViewEditForm = true;
        this.fieldConfig = this.config[index];
        $('#editFormModal').appendTo('body').modal('show');
    }

    closeEditForm() {
        $('#editFormModal').modal('hide');
        this.canViewEditForm = false;
    }


    saveChanges(fieldValues) {
        this.closeEditForm();
        const oldValues = { ...fieldValues.oldValues };
        const newValues = { ...fieldValues.newValues };
        const editedValues = {
            type: oldValues.type,
            editable: oldValues.editable,
            draggable: oldValues.draggable,
            position: oldValues.position,
            label: newValues.fieldLabel,
            name: newValues.fieldIdentifier,
            placeholder: newValues.fieldPlaceholder,
            validatorInfo: {
                required: newValues.fieldRequired,
                email: oldValues.validatorInfo.email
            },
            labelMaxCharacters: oldValues.labelMaxCharacters,
            labelMaxRows: oldValues.labelMaxRows
        };
        // if the field is made required after editing, then add the "required" validator to the field
        if (newValues.fieldRequired) {
            if (oldValues.input === 'input' && oldValues.input_type === 'email') {
                editedValues['validators'] = [...oldValues['validators'], Validators.required];
            } else {
                editedValues['validators'] = [Validators.required];
            }
        }
        // if it is a select/checkbox/radio field, then add the options to the field
        if (newValues.fieldOptions.length > 0 && (oldValues.type === 'select' || oldValues.type === 'radio')) {
            editedValues['options'] = [...newValues.fieldOptions];
        } else if (newValues.fieldOptions.length > 0 && oldValues.type === 'checkbox') {
            editedValues['choices'] = [...newValues.fieldOptions];
        }

        if (newValues.convertToTag && (oldValues.type === 'select' || oldValues.type === 'radio' || oldValues.type === 'checkbox')) {
            editedValues['convertToTag'] = newValues.convertToTag;
        }

        if (newValues.eeo) {
            editedValues['eeo'] = newValues.eeo;
        }

        // If the choices or options are 0, then dont save changes.
        if (newValues.fieldOptions.length <= 0 && (oldValues.type === 'select' || oldValues.type === 'radio')) {
            editedValues['options'] = [...oldValues.options];
        } else if (newValues.fieldOptions.length <= 0 && oldValues.type === 'checkbox') {
            editedValues['choices'] = [...oldValues.choices];
        }
        // if it is an input field, then decide the type of input. Ex: text, date, password, etc.
        if (oldValues.input_type) {
            editedValues['input_type'] = oldValues.input_type;
        }
        this.config[oldValues.position - 1] = { ...editedValues };
        // console.log('New field values: ', editedValues);
        // console.log('Old field values: ', oldValues);
        this.configService.editConfig([...this.config]);
        console.log(this.config);
    }

    getControlType(field) {
        field["controlType"] = "design";

        //Added a new property convertToTag, supporting older forms
        //if (field.type === 'select' || field.type === 'radio' || field.type === 'checkbox') {
        //    field['convertToTag'] = field.convertToTag ? field.convertToTag : false;
        //}
        return field;
    }

}
